<template>
  <div class="listing-page">
    <header class="header">
      <div class="row">
        <div class="columns small-12 medium-8">
          <div class="text-widget subheader">Curated collections of teaching resources</div>
          <h1>{{ title }}</h1>
          <p>
            Carefully curated resource packs that provide you with all the resources you need to
            teach a specific topic or theme your classroom. Each teaching resource pack contains
            specifically designed, engaging
            <nuxt-link to="/teaching-resources/" title="View latest teaching resources">
              teaching resources
            </nuxt-link>
            .
          </p>
        </div>
      </div>
    </header>

    <resources-list
      :pagination="true"
      :params="params"
      :col-count="5"
      :available-filters="availableFilters"
    />
  </div>
</template>

<script>
/* Teaching Resource Packs
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components: ResourcesList
 * @methods:
 */

import { mapGetters } from 'vuex';
import ResourcesList from '~/components/resource/ResourcesList.vue';

export default {
  name: 'TeachingResourcePacksIndex',
  components: {
    ResourcesList,
  },
  data() {
    return {
      title: 'Teaching Resource Packs',
      description:
        'Carefully curated resource packs that provide you with all the resources you need to teach a specific topic or theme your classroom.',
      params: {
        country: this.$i18n.locale,
        perPage: 30,
        types: ['resource-pack'],
      },
      availableFilters: [
        'learning_areas',
        'resource_types',
        'availability',
        'file_formats',
        'publishers',
      ],
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        { hid: 'description', name: 'description', content: this.description },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
  computed: {
    ...mapGetters(['widgets']),
  },
  mounted() {
    this.$mzAnalyticsApi({
      event: 'pageView',
    });
  },
};
</script>
